import { makeRoute } from "@flow/common/route";
import * as Safe from "safe-portals";
import * as perm from "@flow/common/core_permissions";

export const getSiteKey = makeRoute(
  "/api/recaptcha/site_key",
  "public",
  Safe.nothing,
  Safe.obj({
    site_key: Safe.optional(Safe.str),
  })
);

export const getSettings = makeRoute(
  "/admin/api/recaptcha/get_settings",
  [perm.VIEW_SETTINGS],
  Safe.nothing,
  Safe.obj({
    bot_threshold: Safe.optional(Safe.float),
    site_key: Safe.optional(Safe.str),
    secret_key: Safe.optional(Safe.str),
  })
);

export const setSettings = makeRoute(
  "/admin/api/recaptcha/set_settings",
  [perm.UPDATE_SETTINGS],
  Safe.obj({
    bot_threshold: Safe.optional(Safe.float),
    site_key: Safe.optional(Safe.str),
    secret_key: Safe.optional(Safe.str),
  }),
  Safe.nothing
);
